import * as React from 'react'
import { cn } from '@/lib/utils'

/* 输入控件 16px 字号下限 — iOS 上 <16px 的 input/select/textarea 聚焦会触发页面缩放。
   [font-size:1rem] 用 arbitrary property（utilities 层排在 text-xs 之后），调用方的 text-xs
   不再把控件压回下限之下；字号仍是 rem（html=16px）。默认不锁字体 —— 继承 body sans，
   机器值（sk-* / id / hash）调用方仍可 className="font-mono" 覆盖；人类文本字段保持 sans。 */
const controlText = '[font-size:1rem] leading-6 text-enterprise-text'

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        `flex h-[var(--control-h)] w-full rounded-control border border-enterprise-border bg-enterprise-surface px-3 py-1 ${controlText} placeholder:text-enterprise-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-enterprise-indigo focus-visible:border-enterprise-indigo focus-visible:ring-offset-2 focus-visible:ring-offset-enterprise-bg disabled:opacity-50 motion-reduce:transition-none`,
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
)
Input.displayName = 'Input'

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => (
    <textarea
      className={cn(
        `flex min-h-[80px] w-full rounded-control border border-enterprise-border bg-enterprise-surface px-3 py-2 ${controlText} placeholder:text-enterprise-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-enterprise-indigo focus-visible:border-enterprise-indigo focus-visible:ring-offset-2 focus-visible:ring-offset-enterprise-bg disabled:opacity-50 motion-reduce:transition-none`,
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
)
Textarea.displayName = 'Textarea'

export const Select = React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <select
      className={cn(
        `flex h-[var(--control-h)] w-full rounded-control border border-enterprise-border bg-enterprise-surface px-3 py-1 ${controlText} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-enterprise-indigo focus-visible:border-enterprise-indigo focus-visible:ring-offset-2 focus-visible:ring-offset-enterprise-bg disabled:opacity-50 motion-reduce:transition-none`,
        className,
      )}
      ref={ref}
      {...props}
    >
      {children}
    </select>
  ),
)
Select.displayName = 'Select'

export const Label = ({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) => (
  <label className={cn('text-sm font-medium tracking-tight text-enterprise-muted', className)} {...props} />
)
